import { Integration } from "/app/src/models";
import LineFields from "./lineFields";
import OrderFields from "./orderFields";
import DataHook from "./dataHook";
import DisabledWrapper from "/app/src/components/generic/components/disabledWrapper";
import { useTranslation } from "react-i18next";
/**
 * Component to display the settings for a single Data Pull or Data Push Integration
 */
export default function Fields({ integration }: { integration: Integration }) {
  const { lineFields, orderFields, updateField, createField, deleteField } =
    DataHook(integration);
  const { t } = useTranslation();

  const hasLocationOrderFields = (fields: Array<{ name?: string }>) => {
    const locations = new Set([
      "storageUnits",
      "zones",
      "carriers",
      "locations",
      "shelves",
    ]);
    if (!Array.isArray(fields)) return false;
    return fields.some(
      (f) => f && typeof f.name === "string" && locations.has(f.name),
    );
  };
  return (
    <>
      <OrderFields
        integration={integration}
        orderFields={orderFields}
        updateField={updateField}
        createField={createField}
        deleteField={deleteField}
      />
      <DisabledWrapper
        disabled={hasLocationOrderFields(orderFields)}
        tooltip={t("translation:order_lines_not_available")}
      >
        <LineFields
          integration={integration}
          lineFields={lineFields}
          updateField={updateField}
          createField={createField}
          deleteField={deleteField}
        />
      </DisabledWrapper>
    </>
  );
}
